export default __webpack_public_path__ + "static/media/selected.866e8f34.svg";